import React from 'react';
import { arrayOf, node, oneOf, oneOfType, shape, string, object } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { Container, Message } from './alert-text.styles';

function AlertText({
  message,
  intent,
  icon,
  styleContainer,
  styleMessage
}) {
  const renderIcon = messageIcon => {
    if (typeof messageIcon !== 'string') return icon;
    return /*#__PURE__*/React.createElement(Icon, {
      color: (styleMessage == null ? void 0 : styleMessage.color) || `alert.${intent}.text`,
      name: messageIcon,
      "data-testid": "alert-icon"
    });
  };

  const renderMessage = messageContent => {
    const messageIcon = (messageContent == null ? void 0 : messageContent.icon) || icon;
    return /*#__PURE__*/React.createElement(React.Fragment, null, messageIcon && renderIcon(messageIcon), typeof messageContent === 'string' ? messageContent : (messageContent == null ? void 0 : messageContent.text) || messageContent);
  };

  return /*#__PURE__*/React.createElement(Container, {
    intent: intent,
    "data-testid": "alert-container",
    style: styleContainer
  }, Array.isArray(message) ? message.map((text, index) => /*#__PURE__*/React.createElement(Message, {
    key: `alert-message-${index}`,
    intent: intent,
    "data-testid": "alert-text",
    style: styleMessage
  }, renderMessage(text))) : /*#__PURE__*/React.createElement(Message, {
    intent: intent,
    "data-testid": "alert-text",
    style: styleMessage
  }, renderMessage(message)));
}

AlertText.defaultProps = {
  message: '',
  intent: 'info',
  icon: null,
  styleContainer: {},
  styleMessage: {}
};
process.env.NODE_ENV !== "production" ? AlertText.propTypes = {
  message: oneOfType([string, arrayOf(oneOfType([string, shape({
    text: string,
    icon: oneOfType([node, string])
  })])), shape({
    text: string,
    icon: oneOfType([node, string])
  })]),
  intent: oneOf(['info', 'success', 'warning', 'danger']),
  icon: oneOfType([node, string]),
  styleContainer: object,
  styleMessage: object
} : void 0;
export default AlertText;